import { useEffect, useMemo, useRef, useState } from "react"
import { callautopopulate } from "../../../services/callautopop";
import { useCommon } from "./useCommon";
import _ from "underscore";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { dateConvert, getFullMonthSelected, parseExcelFormula } from "../../../utils/Helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import globalFilterStore from "../../../Store/globalFilterStore";
import { useCommon as getPermission } from "../../Common/useCommon";
import { DateTime } from 'luxon';

export const useDeclared = () => {

    const { getSubProject } = useCommon();
    const { getValuePermission } = getPermission()
    const tagRef = useRef(null);
    const [options, setOptions] = useState({ projects: [], sprint: [], issueType: [], subProject: [], reporters: [] });
    const [loader, setLoader] = useState(false);
    const [revoke, setRevoke] = useState({ show: false, data: [] });
    const [pagination, setPagination] = useState({ total_records: 0, total_pages: 0, current_page: 1, display_page_out_of_total: "" });
    const [bidsDetails, setBidDetails] = useState({ visible: false, data: [], winner: 0 });
    const [expanded, setExpanded] = useState(true);
    const [configColumn, setConfigColumn] = useState({ show: false, data: [] });
    const [rowKey, setRowKey] = useState([])
    const store = globalFilterStore();
    const [rowData, setRowData] = useState([]);
    const { commonFilter, setCommonFilter, projectWiseData, setProjectWiseData } = store;
    const [filterValues, setFilterValues] = useState({ ...commonFilter });
    const [taskDetailsPopup, setTaskDetailsPopup] = useState({ show: false, hoveredId: 0 });
    const historyCols = [
        {
            key: "bidder_name",
            label: "Bidder",
            style: { width: "20%" },
        },
        {
            key: "bid_info",
            label: "Hours",
            headerStyle: { textAlign: "center" },
            style: { textAlign: "center", width: "10%" },
        },
        {
            key: "submit_datetime",
            label: "Submitted",
            style: { width: "20%" },
            render: (row) => {
                return (
                    <div className="py-1">{row?.submit_datetime ? dateConvert(row?.submit_datetime, "date-time-months") : ""}</div>
                )
            }
        },
        {
            key: "declared_datetime",
            label: "Declared",
            style: { width: "20%" },
            render: (row) => {
                return (
                    <div className="py-1">{row?.declared_datetime ? dateConvert(row?.declared_datetime, "date-time-months") : ""}</div>
                )
            }
        },
        {
            key: "remark",
            label: "Remark",
            style: { width: "30%" },
            render: (row) => {
                return (
                    <div title={row?.remark}>{row?.bidder_user_code === bidsDetails?.winner ? row?.remark : ""}</div>
                )
            }
        },
    ]

    const columnsDef = [
        {
            key: "issue_key",
            label: "Task ID",
            style: { fontWeight: "500", width: "100px" },
            headerStyle: { textAlign: "center" },
            filter: true,
            render: (row) => {
                const isHovered = taskDetailsPopup?.hoveredId === row?.issue_id;
                return <div className="d-flex justify-content-between align-items-center pe-1" onMouseEnter={() => setTaskDetailsPopup((prev) => ({ ...prev, hoveredId: row?.issue_id }))} onMouseLeave={() => setTaskDetailsPopup((prev) => ({ ...prev, hoveredId: 0 }))}>
                    <div className={`d-flex gap-2 align-items-center ${isHovered ? "w90" : "w100"}`}>
                        <img src={row?.issue_type_image_url} alt="" width={16} height={16} />
                        <div className="c-pointer fw-semibold text-decoration-underline text-truncate" onClick={() => setTaskDetailsPopup((prev) => ({ ...prev, show: true, data: row }))}>{row?.issue_key}</div>
                    </div>
                    {isHovered && <a href={row?.issue_url} target="_blank" className="w10 text-secondary"><FontAwesomeIcon icon="fa-solid fa-link" /></a>}
                </div>
            }
        },
        {
            key: "issue_summary",
            label: "Task Name",
            filter: true,
            style: { width: "350px", flex: 1 },
            render: (row) => {
                return (
                    <div className="py-2 text-truncate" title={row?.issue_summary}>{row?.issue_summary}</div>
                )
            }
        },
        {
            key: "complexity",
            label: "Complexity",
            filter: true,
            headerStyle: { textAlign: "center" },
            style: { textAlign: "center", width: "120px" },
            hide: !commonFilter?.taskType,
            sort: false,
        },
        {
            key: "longitivity",
            label: "Longitivity",
            filter: true,
            headerStyle: { textAlign: "center" },
            style: { textAlign: "center", width: "120px" },
            hide: !commonFilter?.taskType,
            sort: false,
        },
        {
            key: "user_display_name",
            label: commonFilter?.taskType ? "Winner" : "Alloted",
            filter: true,
            style: { width: "140px" },
            render: (row) => {
                return (
                    <div>{row?.user_display_name}</div>
                )
            }
        },
        {
            key: "bid_info_decimal",
            label: "Original Estimate",
            headerStyle: { textAlign: "center", padding: 0 },
            style: { textAlign: "center", width: "80px", padding: 0 },
            hide: !commonFilter?.taskType,
            render: (row) => {
                const [min, max] = row?.matrix_range?.split("-")?.map(item => parseFloat(item?.trim()));
                const bidInfo = parseFloat(row?.bid_info_decimal);
                let bg = "";
                if (!getValuePermission("time_matrix_column")) {
                    if (bidInfo >= min && bidInfo <= max) {
                        bg = "#cce9d5";
                    } else if (bidInfo < min) {
                        bg = "#fef3c7";
                    } else if (bidInfo > max) {
                        bg = "#fee2e2";
                    }
                }
                return <div className="fw-bold py-2 " style={{ backgroundColor: bg }}>{row?.bid_info_decimal}</div>
            }
        },
        {
            key: "time_original_decimal",
            label: "Logged Hours",
            headerStyle: { textAlign: "center", padding: 0 },
            style: { textAlign: "center", width: "80px", padding: 0 },
            hide: !commonFilter?.taskType,
        },
        {
            key: "lead_estimate_decimal",
            label: "Lead Estimate",
            headerStyle: { textAlign: "center", padding: 0 },
            style: { textAlign: "center", width: "80px", padding: 0 },
            hide: !commonFilter?.taskType,
        },
        {
            key: "time_matrix",
            label: "Time Matrix",
            style: { width: "100px", textAlign: "center" },
            headerStyle: { textAlign: "center" },
            hide: getValuePermission("time_matrix_column") || !commonFilter?.taskType,
            render: (row) => {
                return (
                    <p className="fw-bold">{row?.matrix_range}</p>
                );
            }
        },
        {
            key: "total_bids",
            label: "Total Bids",
            headerStyle: { textAlign: "center" },
            style: { textAlign: "center", textAlign: "center", width: "100px", },
            hide: !commonFilter?.taskType,
            render: (row) => {
                return (
                    <div className="c-pointer text-decoration-underline fw-semibold" onClick={() => setBidDetails((prev) => ({ ...prev, visible: true, data: row?.all_bids_info, winner: row?.alloted_user_code }))} title="Bid History">{row?.total_bids}</div>
                )
            }
        },
        {
            key: "declared_datetime",
            label: "Declare Date",
            style: { width: "140px", },
            hide: !commonFilter?.taskType,
            render: (row) => {
                return (
                    <div style={{ fontSize: "0.8rem" }} >{row?.declared_datetime ? dateConvert(row?.declared_datetime, "date-time-months") : "-"}</div>
                )
            }
        },
        {
            key: "status_name",
            label: "JIRA Status",
            filter: true,
            headerStyle: { textAlign: "center" },
            style: { textAlign: "center", width: "120px", }
        },

        {
            key: "complexity_value",
            label: "Complexity Weight",
            style: { width: "80px", textAlign: "center" },
            headerStyle: { textAlign: "center" },
            hide: getValuePermission("complexity_longevity_weight") || !commonFilter?.taskType,

        },
        {
            key: "longevity_value",
            label: "Longevity Weight",
            headerStyle: { textAlign: "center" },
            style: { textAlign: "center", width: "80px", },
            hide: getValuePermission("complexity_longevity_weight") || !commonFilter?.taskType,
        },
    ]

    useEffect(() => {
        callautopopulate("projects", "user_info").then((res) => {
            setOptions((prev) => ({
                ...prev,
                projects: _.sortBy(res?.projects, "project_name"),
                userCode: res?.user_info[0]?.user_code,
            }))
            if (commonFilter?.projects?.length > 0) {
                handleFilterChange(res?.user_info[0]?.user_code);
            } else {
                setOptions((prev) => ({ ...prev, apiCall: true }));
            }
        })
        getWeightMetricsFormula()
    }, []);

    useEffect(() => {
        options?.apiCall && getDeclareDetails();
    }, [options?.apiCall]);

    useEffect(() => {
        !_.isEqual(commonFilter, filterValues) && setCommonFilter({ ...commonFilter, ...filterValues });
    }, [filterValues])

    useEffect(() => {
        !_.isEqual(commonFilter, filterValues) && setFilterValues((prev) => ({ ...prev, ...commonFilter }));
    }, [commonFilter])

    const columns = useMemo(() => {
        const generateDynamicKeyMap = (staticCols) => {
            const mapping = {};
            staticCols.forEach(col => {
                if (col.label && col.key) {
                    mapping[col.label.toLowerCase()] = col.key;
                }
            });
            return mapping;
        };
        const staticKeyMap = generateDynamicKeyMap(columnsDef);
        const activeFormulas = (configColumn?.data || []).filter(f => f.is_active);
        const sampleRow = rowKey || {};
        const rowKeys = Object.keys(sampleRow).map(k => k.toLowerCase());

        const dynamicLabels = activeFormulas.map(f => f.column_display_name.toLowerCase());
        const staticLabels = Object.keys(staticKeyMap);
        const allLabels = [...staticLabels, ...dynamicLabels, ...rowKeys].sort((a, b) => b.length - a.length);

        const dynamicFormulaCols = activeFormulas.map((f) => ({
            key: `formula_${f.formula_id}`,
            label: f.column_display_name,
            headerStyle: { textAlign: "center" },
            style: { textAlign: "center", width: "120px", fontWeight: "bold" },
            hide: !commonFilter?.taskType || getValuePermission("config_declare_columns"),
            render: (row) => {
                let tempRow = { ...row };

                activeFormulas.forEach((formulaObj) => {
                    let expr = formulaObj.column_expression;

                    allLabels.forEach((label) => {
                        const regex = new RegExp(`\\b${label}\\b`, 'gi');
                        const actualKey = staticKeyMap[label];
                        const val = actualKey
                            ? (tempRow[actualKey] ?? 0)
                            : (tempRow[label] ?? 0);

                        expr = expr.replace(regex, val);
                    });

                    const valid = expr.startsWith('=') ? expr : `=${expr}`;
                    const result = parseExcelFormula(valid, tempRow, Object.keys(tempRow));
                    tempRow[formulaObj.column_display_name.toLowerCase()] = result;
                });

                const finalValue = tempRow[f?.column_display_name?.toLowerCase()];
                return (
                    <div className="fw-bold">
                        {finalValue === "#VALUE!" || finalValue === "Infinity" ? 0 : finalValue}
                    </div>
                );
            }
        }));

        return [...columnsDef, ...dynamicFormulaCols, {
            key: "revoke",
            label: "Revoke",
            pinned: "right",
            style: { textAlign: "center", width: "50px" },
            render: (row) => (
                <div
                    className="text-danger text-center c-pointer"
                    onClick={() => setRevoke({ show: true, data: [row.issue_id], product_code: row?.product_code })}
                >
                    <FontAwesomeIcon icon="fa-solid fa-hand-point-left" />
                </div>
            )
        }];
    }, [columnsDef, configColumn?.data]);

    const getDeclareDetails = async (key) => {
        try {
            setLoader(true);
            const fullMonth = getFullMonthSelected(DateTime.fromJSDate(new Date(commonFilter?.month)));
            const payload = {
                project_ids: commonFilter?.projects?.toString() || "",
                sub_project_ids: commonFilter?.subProject?.toString() || "",
                sprint_ids: commonFilter?.sprint?.toString() || "",
                issuetype_ids: commonFilter?.issueType?.toString() || "",
                reporter_user_code: commonFilter?.reporters?.toString() || "",
                issue_keys: commonFilter?.issueKey || "",
                page_number: pagination?.current_page > 0 ? pagination?.current_page - 1 : pagination?.current_page || 0,
                is_bucket_enable: commonFilter?.taskType,
                from_date: DateTime.fromJSDate(new Date(fullMonth?.from_date)) || "",
                to_date: DateTime.fromJSDate(new Date(fullMonth?.to_date)) || "",
            }
            const res = await services.getInvokeRemote("POST", Urls("PGETBUCKETDECLAREDETAILS"), payload);
            if (res) {
                const data = res?.body?.data?.bucket_declare_details;
                const totalBids = res?.body?.data?.bucket_total_bid_details;
                const paginationData = res?.body?.data?.issue_paging?.[0];
                setPagination((prev) => ({ ...prev, total_records: paginationData?.total_issues, total_pages: paginationData?.paging, display_page_out_of_total: paginationData?.current_records }))

                let bids = {};
                const grouped = {};
                _.sortBy(data, "issue_key")?.forEach(issue => {
                    const featureKey = issue?.features_issue_key;
                    if (featureKey) {
                        if (!grouped[featureKey]) {
                            grouped[featureKey] = {
                                id: featureKey,
                                title: issue?.features_issue_summary || featureKey,
                                children: []
                            };
                        }
                        issue["total_bids"] = _.filter(totalBids, { issue_id: issue?.issue_id })?.length || 0
                        issue["all_bids_info"] = _.filter(totalBids, { issue_id: issue?.issue_id });
                        grouped[featureKey].children.push(issue);
                        bids = { ...bids, [issue?.issue_id]: issue?.bid_seconds }
                    }
                });
                setRowKey(data[0])
                setRowData(Object.values(grouped));
                setCommonFilter({ ...commonFilter, isChange: false, totalTasks: _.pluck(Object.values(grouped), "children")?.flatMap(item => item)?.length })
            }
        } catch (error) {
            console.error("Error: ", error);
        } finally {
            setLoader(false);
            setOptions((prev) => ({ ...prev, apiCall: false }))
        }
    }

    const handleFilterChange = async (userCode) => {
        const data = await getSubProject(commonFilter?.projects, ["is_sub_project", "is_issue_type", "is_reporter", "is_sprint"], userCode || options?.userCode);
        if (data) {
            setProjectWiseData(data)
            setOptions((prev) => ({ ...prev, apiCall: true }))
        }
    }

    const getWeightMetricsFormula = async () => {
        try {
            const res = await services.getInvokeRemote("POST", Urls("GETWEIGHTMETRICSFORMULADETAIL"), {});
            if (!res?.body?.error_status) {
                setConfigColumn((prev) => ({ ...prev, data: res?.body?.data?.weight_metrics_formula_details }))
            } else {
                setConfigColumn((prev) => ({ ...prev, data: [] }))
            }
        } catch (error) {
            console.error("error:::", error)
        }
    }


    return useMemo(() => ({
        tagRef, handleFilterChange, options, columns, rowData, loader, getDeclareDetails, pagination, setPagination, revoke, setRevoke, bidsDetails, setBidDetails, historyCols, setCommonFilter, commonFilter, projectWiseData, expanded, setExpanded, configColumn, setConfigColumn, getWeightMetricsFormula, getValuePermission, filterValues, setFilterValues, taskDetailsPopup, setTaskDetailsPopup
    }), [tagRef, handleFilterChange, options, columns, rowData, loader, getDeclareDetails, pagination, setPagination, revoke, setRevoke, bidsDetails, setBidDetails, historyCols, setCommonFilter, commonFilter, projectWiseData, expanded, setExpanded, configColumn, setConfigColumn, getWeightMetricsFormula, getValuePermission, filterValues, setFilterValues, taskDetailsPopup, setTaskDetailsPopup])
}